import React from 'react';
import ContentLoader from 'react-content-loader';
import { SKELETON_BACKGROUND, SKELETON_FOREGROUND } from '../../../color';

const TableLoader = (props) => (
  <ContentLoader
    width={1000}
    height={400}
    speed={1}
    viewBox="0 0 1000 400"
    backgroundColor={SKELETON_BACKGROUND}
    foregroundColor={SKELETON_FOREGROUND}
    {...props}
  >
    <rect x="0" y="0" rx="3" ry="3" width="1000" height="17" />

    <rect x="32" y="75" rx="3" ry="3" width="280" height="15" />
    <rect x="820" y="69" rx="3" ry="3" width="141" height="15" />
    <rect x="0" y="110" rx="3" ry="3" width="995" height="2" />

    <rect x="32" y="131" rx="3" ry="3" width="280" height="15" />
    <rect x="820" y="130" rx="3" ry="3" width="141" height="15" />
    <rect x="0" y="171" rx="3" ry="3" width="995" height="2" />

    <rect x="32" y="189" rx="3" ry="3" width="280" height="15" />
    <rect x="820" y="188" rx="3" ry="3" width="141" height="15" />
    <rect x="0" y="229" rx="3" ry="3" width="995" height="2" />

    <rect x="32" y="250" rx="3" ry="3" width="280" height="15" />
    <rect x="820" y="249" rx="3" ry="3" width="141" height="15" />
    <rect x="0" y="290" rx="3" ry="3" width="995" height="2" />

    <rect x="32" y="315" rx="3" ry="3" width="280" height="15" />
    <rect x="820" y="309" rx="3" ry="3" width="141" height="15" />
    <rect x="0" y="350" rx="3" ry="3" width="995" height="2" />

    <rect x="0" y="4" rx="3" ry="3" width="2" height="350" />
    <rect x="995" y="4" rx="3" ry="3" width="2" height="350" />

    <rect x="0" y="35" rx="3" ry="3" width="1000" height="17" />
    <rect x="0" y="12" rx="3" ry="3" width="30" height="33" />
    <rect x="320" y="15" rx="3" ry="3" width="495" height="33" />
    <rect x="970" y="9" rx="3" ry="3" width="30" height="33" />
  </ContentLoader>
);

export default TableLoader;
